<button
  #cmYear
  pButton
  size="small"
  [pTooltip]="
    dataLayer.isForecast
      ? 'Prognosejahr – Rechtsklick für weitere Optionen.'
      : 'Rechtsklick für weitere Optionen.'
  "
  [attr.aria-label]="
    dataLayer.isForecast ? dataLayer.year + ' (Prognose)' : null
  "
  [showDelay]="600"
  [rounded]="true"
  [severity]="dataLayer.isForecast ? 'help' : 'primary'"
  [icon]="iconByPublishedState"
  [label]="dataLayer.year + ''"
  (click)="selectDataLayer()"
  [ngClass]="{
    'p-button-raised p-button-text':
      dataLayer._id !== globalStore.selectedLayer()?._id,
  }"></button>

<p-contextMenu
  appendTo="body"
  [target]="cmYear"
  (onShow)="setItems()"
  [model]="contextMenuItems" />
